import { render, staticRenderFns } from "./TaskDesktop.vue?vue&type=template&id=61bae6bf&"
import script from "./TaskDesktop.vue?vue&type=script&lang=js&"
export * from "./TaskDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports